// extracted by mini-css-extract-plugin
export var arrow = "newsletter-module--arrow--088a4";
export var arrowContainer = "newsletter-module--arrowContainer--f7928";
export var circle = "newsletter-module--circle--cb565";
export var container = "newsletter-module--container--5650b";
export var content = "newsletter-module--content--19d79";
export var emailErrorMessage = "newsletter-module--emailErrorMessage--0b697";
export var emailInput = "newsletter-module--emailInput--376c3";
export var errorCircle = "newsletter-module--errorCircle--da95e";
export var errorMessage = "newsletter-module--errorMessage--ac077";
export var form = "newsletter-module--form--975dd";
export var formContainer = "newsletter-module--formContainer--6a9a7";
export var iframe = "newsletter-module--iframe--10433";
export var image = "newsletter-module--image--78e87";
export var label = "newsletter-module--label--e702c";
export var moveArrow = "newsletter-module--moveArrow--1f9a8";
export var submitButton = "newsletter-module--submitButton--fedc4";
export var subtitle = "newsletter-module--subtitle--4c774";
export var successMessage = "newsletter-module--successMessage--ceb1e";
export var title = "newsletter-module--title--3a208";